import { Outlet, Navigate } from 'react-router-dom'
import { useAuthStore } from '../../store'

export default function AuthLayout() {
  const isAuthenticated = useAuthStore(state => state.isAuthenticated)

  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-800 to-green-600 flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <Outlet />
        <p className="text-center text-green-200 text-sm mt-6">
          Centinela Salud
        </p>
      </div>
    </div>
  )
}
